<template>
    <div>
        <el-table stripe v-loading="loading" :data="dataList" >
            <el-table-column label="代理商" prop="agentNo" min-width="" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    {{scope.row.userNo}} - {{scope.row.userName}}
                </template>
            </el-table-column>
            <el-table-column label="提现账户" prop="accountNo" min-width="" :show-overflow-tooltip="true"/>
            <el-table-column label="申请提现时间" prop="extractionTime" min-width="" :show-overflow-tooltip="true"/>
            <el-table-column label="申请提现金额(元)" prop="extractionAmount" min-width="" :show-overflow-tooltip="true"/>
            <el-table-column label="实际打款金额(元)" prop="actualAmount" min-width="" :show-overflow-tooltip="true"/>
            <el-table-column label="实际打款时间" prop="transferTime" min-width="" :show-overflow-tooltip="true"/>
            <el-table-column label="打款状态" prop="transferStatus" min-width="" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <el-button :type="scope.row.transferStatus=='SUCCESS'?'success':(scope.row.transferStatus=='FAILED' || scope.row.transferStatus=='UNCOMMIT')?'danger':'primary'" 
                    plain size="mini" class="button-status" v-if="scope.row.transferStatus">{{scope.row.transferStatus | transferFM}}</el-button>
                </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" min-width="" :show-overflow-tooltip="true"/>
        </el-table>
        <Pagination v-show="total > 0" :total="total" :page.sync="pageNo" :limit.sync="pageSize" @pagination="getList"/>
    </div>
</template>

<script>
    import {ProfitManage} from '@/api';
    import { mapState } from 'vuex'
    export default {
        name: "ToolBar",
        props: {
            dicts: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            queryParams: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        computed:{
            ...mapState('app', ['userInfo']),
            isOrg(){
                return this.userInfo.org
            },
        },
        data() {
            return {
                pageNo: 1,
                pageSize: 10,
                loading: false,
                total: 0,
                dataList: [],
                selectRow: {},
                showCustomForm: false,
                isAdd: false,
                allCount:''
            }
        },
        watch: {
            queryParams: function () {
                this.pageNo = 1;
                this.getList();
            },
        },
        methods: {
            async getList() {
                this.loading = true;
                let result = await ProfitManage.extractionOrder.queryPage(this.pageNo, this.pageSize, this.queryParams);
                this.loading = false;
                this.total = result.count || 0;
                this.dataList = result.data.orderPageList || [];
                this.allCount = result.data.orderCountInfo || [];
            },
            handlerCustomFormOnclose() {
                this.showCustomForm = false;
                this.getList();
            },
            async handleUpdate(row) {
                this.showCustomForm = true;
                this.selectRow = row;
                this.isAdd = false;
            },
        }
    };
</script>

<style scoped>

</style>
